import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { OKGeneric } from '../models';

extendZodWithOpenApi(z);
const c = initContract();

/**
 * Endpoints for health checks
 */
export const apiHealth = c.router({
  sendHeartbeat: {
    method: 'GET',
    path: `/1.0/health/heartbeat`,
    summary: 'Sends heartbeat to BetterStack',
    description: 'Currently runs every hour (see cron definition in `vercel.json`',
    responses: {
      200: OKGeneric,
    },
  },
  checkHealth: {
    method: 'GET',
    path: `/1.0/health/check`,
    summary: 'Checks the health of the service',
    description:
      'Performs a basic health check of the TIC service. Returns OK if the service is running and responsive. Used by monitoring systems and load balancers to verify service availability.',
    responses: {
      200: OKGeneric,
    },
  },
});
